import React from 'react'

import isEmpty from 'lodash/isEmpty'

import { useLegalAuditDocumentRedaction } from 'manager/hooks/useLegalAuditDocumentRedaction'
import { useGetDocumentDetail } from 'shared/hooks/api'

import { RegularText } from '../Typography'

import { Link } from './styled'

interface DocumentLinkProps {
  documentName: string
  id: string
}

const DocumentLinkWithUrl = ({ documentName, id }: DocumentLinkProps) => {
  const { document, isError, isLoading } = useGetDocumentDetail(id)

  return (
    <>
      {isLoading || isError || isEmpty(document?.url) ? (
        <RegularText>{documentName}</RegularText>
      ) : (
        <Link href={document.url} target="_blank">
          {documentName}
        </Link>
      )}
    </>
  )
}

export const DocumentLink = ({ documentName, id }: DocumentLinkProps) => {
  const { shouldRedactDocuments } = useLegalAuditDocumentRedaction()

  if (shouldRedactDocuments) {
    return <RegularText>{documentName}</RegularText>
  }

  return <DocumentLinkWithUrl documentName={documentName} id={id} />
}
